import { Button, Flex } from "antd";
import React from "react";
import type { IFilter } from "..";
import { useGetCoursesSummeryQuery } from "../../../../app/features/courses/courses.api";
import type { ICourseResponse } from "../../../../app/features/courses/courses.types";
import Title from "../../../../components/ui/Title";
import useError from "../../../../hooks/useError";
import { cn } from "../../../../utils/global.utils";
import { enToBnNumber } from "../../../../utils/number.utils";

type Props = {
  active: IFilter;
  setActive: React.Dispatch<React.SetStateAction<IFilter>>;
  courses?: ICourseResponse[];
};

export default function Filter({ active, setActive }: Props) {
  const { data, error } = useGetCoursesSummeryQuery();
  useError(error, "কোর্স সামারি ডাটা লোড হয়নি");

  const filterList = [
    {
      key: "TOTAL",
      title: "মোট কোর্স",
      count: enToBnNumber(data?.enrolled || 0),
    },
    {
      key: "ACTIVE",
      title: "একটিভ",
      count: enToBnNumber(data?.running || 0),
    },
    {
      key: "COMPLETED",
      title: "কমপ্লিট",
      count: enToBnNumber(data?.completed || 0),
    },
  ];

  return (
    <Flex
      justify="space-between"
      align="center"
      wrap
      className="pb-6 mb-6 border-b border-theme-zinc-200"
      gap={16}
    >
      <Title className="text-2xl">আমার কোর্স সমূহ</Title>

      <Flex align="center" gap={8} wrap>
        {filterList.map((el) => (
          <Button
            size="large"
            className={cn(
              "rounded-full text-sm font-medium !bg-slate-100 !text-theme-zinc-700 border-none min-w-28 h-10 relative -top-[1px]",
              active === el.key && "!text-white !bg-theme-red-500"
            )}
            key={el.key}
            onClick={() => setActive(el.key as IFilter)}
          >
            {el.title} ({el.count})
          </Button>
        ))}
      </Flex>
    </Flex>
  );
}
